import { createAction, props } from '@ngrx/store';

export enum MenuBaseAction {
    ChangeEffectiveDate = '[Menu Filters] Change Effective Date',
    ChangeMenuScope = '[Menu Filters] Change Menu Scope',
    Init = '[Menu Page] Init'
}

export const MenuBaseActions = {
    changeEffectiveDate: createAction(
        MenuBaseAction.ChangeEffectiveDate,
        props<{ effectiveDate: string }>()
    ),
    init: createAction(MenuBaseAction.Init)
};
